import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { observer } from 'mobx-react'
import { Link, withRouter } from 'react-router-dom'
import { generateInvoiceUrl } from '@atheneum/api/dist/lib'
import { invoiceApi } from '@atheneum/api'
import PropTypes from 'prop-types'

class LinkedInvoice extends Component {
  static propTypes = {
    invoice: PropTypes.object
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      linkedInvoice: null
    })

    if (props.invoice.isCreditNote) {
      invoiceApi
        .getLinkedInvoice(props.invoice.id)
        .then(linkedInvoice => {
          this.linkedInvoice = linkedInvoice
        })
        .catch(error => {
          // don't notify the user about error
          // just output it to console
          console.error('Error while fetching linked invoice', error)
        })
    }
  }

  render () {
    if (!this.linkedInvoice) return null

    const linkedInvoiceUrl = generateInvoiceUrl({
      invoiceId: this.linkedInvoice.id,
      contractId: this.linkedInvoice.contractId,
      projectId: this.linkedInvoice.projectId
    })

    return (
      <div className='invoice-details__item'>
        <span>Credit note for</span>
        <Link to={linkedInvoiceUrl}>{this.linkedInvoice.name}</Link>
      </div>
    )
  }
}

export default withRouter(observer(LinkedInvoice))
